import React from 'react';
import { useState } from "react";

import { Helmet } from 'react-helmet';
import Program from './section/Program';
import TestimonialSlider from './animation/TestimonialSlider';
// import { Link } from 'react-router-dom';
import { Underline } from './section/Underline';


function About(){
   

    const [expandedSections, setExpandedSections] = useState({
        aboutProgram: false,
        enhancingEmployability: false,
        skillEnhancement: false,
        higherEducation: false,
        hospitality: false,
        others: false
      });
    // Function to toggle section expansion
    const toggleSection = (sectionKey) => {
      setExpandedSections(prev => ({
        ...prev,
        [sectionKey]: !prev[sectionKey]
      }));
    };
    
    // Function to truncate text
    const truncateText = (text, maxLength) => {
      if (text.length <= maxLength) return text;
      return text.slice(0, maxLength) + '...';
    };
    
    return(
     <>
        <Helmet>
        <title>About | Joining Hands</title>
      </Helmet>
    

    <main>
        {/* <!-- Page banner area start here --> */}
        <section className="border  border-2 border-black banner__inner-page bg-image pt-160 pb-160 bg-image" style={{backgroundImage: "url('images/banner/about-banners.jpg')",position: "relative"}}
            >
                <div 
    className="overlay" 
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(1, 0, 0, 0.5)'
    }}
  ></div>
                
            <div className="container overlay_content">
                <h2 className="wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">About Us</h2>
                <div className="breadcrumb-list wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                    <a href="index.html">Home</a><span className='text-white'><i className="fa-regular fa-angles-right mx-2"></i>About
                        Us</span>
                </div>
            </div>
        </section>
        {/* <!-- Page banner area end here --> */}

        {/* <!-- About area start here --> */}
        <section className="about-two-area pt-120 pb-120 overflow-hidden">
            <div className="about-two__wrp">
                <div className="container">
                    <div className="row g-4 align-items-center">
                        <div className="col-lg-6 wow fadeInLeft" data-wow-delay="200ms" data-wow-duration="1500ms">
                            <div className="about-two__image image pr-60">
                                <img src="images/about/about.jpg" alt="about"/>
                                <div className="line-shape sway_Y__animation">
                                    <img src="images/shape/about-line.png" alt="shape"/>
                                </div>
                                <div className="dot-shape sway__animation">
                                    <img src="images/shape/about-dot3.png" alt="shape"/>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="section-header mb-20">
                                <h5 className="wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                                    <i className="fa-regular fa-angles-left pe-1"></i> ABOUT US <i
                                        className="fa-regular fa-angles-right ps-1"></i>
                                </h5>
                                <h2 className="wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">Joining Hands</h2>
                                <p className="wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">Joining hands is a non-profit organization working towards enhancing employability of the underprivileged youth through skill development and scholarship for higher education. All efforts are in the direction of empowering the youth such that they find gainful employment and become financially sustainable thereby becoming positively contributing members of not only national GDP in particular but society at large.
                                </p>
                            </div>
                            <div className="about-two__content">
                                <div className="item mb-30 wow fadeInDown" data-wow-delay="00ms" data-wow-duration="1500ms">
                                <div className="icon service__item first">
                                        <img src="/images/icon/mission-icon1.png" alt="icon"/>
                                    </div>
                                    <div className="content">
                                        <h6 className="mb-10">Vision</h6>
                                        <p>To socially and economically empower the youth who act as agents of change in creating a more equitable world.</p>
                                    </div>
                                </div>
                                <div className="item wow fadeInDown" data-wow-delay="200ms" data-wow-duration="1500ms">
                                    <div className="icon service__item">
                                        <img src="/images/icon/mission-icon2.png" alt="icon"/>
                                    </div>
                                    <div className="content">
                                        <h6 className="mb-10">Mission</h6>
                                        <p>Skill development & enhancing employability by providing education, training and developing skills of urban poor youth.</p>
                                    </div>
                                </div>
                                <div className="d-flex align-content-center flex-wrap gap-4 mt-40 wow fadeInDown"
                                    data-wow-delay="400ms" data-wow-duration="1500ms">
                                    
                                    {/* <div className="info-video">
                                        <a className="video-popup" href="https://www.youtube.com/watch?v=ElG5-nXD0B8"><i
                                                className="fa-solid fa-play"></i></a>
                                        <h6>Intro Video</h6>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* <!-- About area end here --> */}

         {/* who we are  */}
         <section className="about-two-area pt-120 pb-120 overflow-hidden sub-bg">
            <div className="about-two__wrp">
                <div className="container">
                    <div className="row g-4 align-items-center">
                        
                        <div className="col-lg-6">
                            <div className="section-header mb-20">
                                <h2 className="wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">Who are we</h2>
                                  
                        <div className="content-wrapper">
                        {expandedSections.aboutProgram ? (
                              <>
                                <p className="wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
                                We bridge the gap, empower, listen, support, walk alongside you, teach, help, and are always here for you. <br/>
                                But who are we?
                                </p>
                                <p className="wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
                                We are a team of highly motivated, self-driven, and compassionate professionals bound by a shared vision to socially and economically empower youth who become agents of change in creating a more equitable world. We are deeply committed to this mission.
                                </p>
                                <p className="wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
                                We work tirelessly to create programmes and industry-based learning curriculums that prepare young people for a better future by making them job-ready.
                                </p>
                                <p className="wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
                                Empathy and sensitivity, combined with professional experience and a deep understanding of our focus groups, enable us to build a strong two-way bond of trust and shared purpose.
                                </p>
                                <p className="wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
                                With a focus on the all-round development of urban poor youth, our team designs programmes that shape a brighter and more secure future for them. At Joining Hands, we strive to help our students realise their true potential, believe in their abilities, and break the cycle of poverty and vulnerability.
                                </p>
                                <p className="wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
                                We bring together teachers, mentors, advisors, guidance counsellors, subject-matter experts, clinical psychologists, analysts, and communication trainers, all under one roof.
                                </p>
                              
                                <button 
                                  onClick={() => toggleSection('aboutProgram')}
                                  className="read-more-btn"
                                >
                                  Read Less
                                </button>
                              </>
                          ):(
                            <>
                             <p className="wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
                               We bridge the gap, empower, listen, support, walk alongside you, teach, help, and are always here for you. But who are we?
                                </p>
                                <p className="wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
                                We are a team of highly motivated, self-driven, and compassionate professionals bound by a shared vision to socially and economically empower youth who become agents of change in creating a more equitable world. We are deeply committed to this mission.
                                </p>
                             <p className="mb-2 mt-20 fw-500 text-justify">
                            {truncateText("We work tirelessly to create programmes and industry-based learning curriculums that prepare young people for a better future by making them job-ready...", 200)}
                          </p>
                          <button 
                            onClick={() => toggleSection('aboutProgram')}
                            className="read-more-btn"
                          >
                            Read More
                          </button>
                        </>
                      )}
                    
                   </div >
                            </div>
                           
                        </div>
                        <div className="col-lg-6 wow fadeInLeft" data-wow-delay="200ms" data-wow-duration="1500ms">
                            <div className="about-two__image image ">
                                <img src="/images/banner/who_are_we.jpg" alt="about"/>
                                {/* <div className="line-shape sway_Y__animation">
                                    <img src="images/shape/about-line.png" alt="shape"/>
                                </div> */}
                                <div className="dot-shape sway__animation">
                                    {/* <img src="images/banner/who_are_we.jpg" alt="shape"/> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>


          {/* end who we are  */}
        {/* <!-- Service area start here --> */}
          <section className='service-area pt-100 pb-100 '>
         <Program/>
         </section>
       
        {/* <!-- Service area end here --> */}

        

           {/* <!-- board of trustee --> */}
         <section className="team-area pt-120 pb-120 sub-bg">
            <div className="container">
                <div className="section-header mb-60 text-center">
                    
                    <h2 className="wow fadeInUp " data-wow-delay="200ms" data-wow-duration="1500ms">Board of Trustees</h2>
                    <Underline/>
                </div>
                <div className="row g-4">
                    <div className="col-lg-4 col-sm-6 wow  fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                        <div className=" image">
                             {/* <img  src="images/team/board-1.jpg" alt="image-alt"/> */}
                            <div className="">
                              
                                <div className="content border border-2 bg-white rounded-lg text-center py-3">
                                    <h4><a href="team-single.html" className="primary-hover">Mr. Ardeshir B K Dubash</a></h4>
                                    <span>Chairman</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-sm-6 wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                        <div className=" image">
                             {/* <img src="images/team/board-2.jpg" alt="image-alt"/> */}
                            <div className="rounded-lg">
                                
                                <div className="content text-center bg-white rounded-lg border border-2 py-3">
                                    <h4><a href="team-single.html" className="primary-hover">Mr. Rajendra Arora
                                   </a></h4>
                                     {/* <h4><a href="team-single.html" className="primary-hover">
                                      Mr. Sharang Shah </a></h4> */}
                                    <span>Trustee</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-sm-6 wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
                        <div className=" image">
                            {/* <img src="images/team/board-3.jpg" alt="image-alt"/> */}
                            <div className="rounded-lg">
                               
                                <div className="content text-center bg-white rounded-lg border border-2 py-3 ">
                                    <h4><a href="team-single.html" className="primary-hover">Ms. Kavita Shah</a></h4>
                                    <span>Advisor</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
          {/* <!-- board of trustee --> */}

          <section className='team-area pt-120 pb-50'>
           <div className="container">
               
               <div className="project-single__item">
                  
                   <h3 className="fs-30 mb-30">Since When</h3>
                   <p className="">It was in 2006 when the first ever volunteering programme was successfully launched by joining hands. The programme was a huge hit and gave us the path ahead. After facilitating many successful volunteering programs for the next six years, Joining Hands realized that there is so much that can be done to fill the gaps that only a volunteer program was not enough. Thus, in 2012 the first ever course on enhancing employability was launched. It was able to bridge the gaps that were creating major hurdles for the school drop outs to earn a decent living.
                   </p>
                   <p className=""><b>Since then Joining Hands has been working tirelessly towards creating a work force that is  trained, skilled and is equipped with the right knowledge to their respective sector.</b>
                   </p>
                   <p>
                  <b> Specialized programs, skill enhancement training and sector-based knowledge sessions created by joining hands have been major tools to create employable youth. (here) The under privileged youth that earlier found no footing in the job scenario, is now able to find decent jobs and are becoming the major contributors to the family income.</b>

                   </p>
                   <p>
                   Over the years we extended our reach to creating opportunities to complete higher education for the students that are meritorious but struggle financially. Our scholarship program carves the path for the deserving students by taking off the burden of fee payments.
                    There has been no looking back since then, and with each passing batch Joining Hands has widened its reach to more and more urban youth.  
                   </p>
                  
               </div>
           </div>
          

          </section>

          <section className='team-area  pt-120 pb-50 sub-bg'>
             <div className="container ">
                <div className="section-header mb-60 text-center">
                    
                    <h2 className="wow fadeInUp " data-wow-delay="200ms" data-wow-duration="1500ms">Some major milestones
                    </h2>
                    <Underline/>
                    <p className='fs-18 fw-700 text-center'>In the course of our work we achieved some major landmarks that further strengthened our community presence.</p>

                </div>
               


              

               
            </div>
          </section>

          <section className='team-area pt-50 sub-bg'>
          <div className='container'>
                 <div className=" row px-0 align-items-center ">
                   <div className="col-md-7 ">
                     {/* <h4 class="  py-2 fs-30 fw-bold ">Work with us</h4> */}
                     <div>
                       <p class=" mb-2 mt-20  fw-500 text-justify">
                        <b>
                       The launch of our scholarship program in June 2016 has reached out to a large number of beneficiaries till date. Joining hands has been highly instrumental in helping the beneficiaries not only complete their higher education but also secure decent jobs.
                       </b>
                       </p>
                     </div>
                   </div>
                   <div className="col-md-5 image_box ">
                     <img src="/images/project/other-14.jpg" alt="" />
                     {/* <span className="blog-tag">{tag}</span> */}
                   </div>
                 </div>
                 </div>

          </section>

          <section className='team-area  pt-50 sub-bg'>
            <div class="container ">
                     <div class="row g-4">
                        <div class="col-lg-12 order-2 order-lg-1">
                       <div class="blog__item blog-single__left-item shadow-none">
                 
                  <div class="blog__content p-0  wow fadeInDown">
                    <div class="container">      
                     <div className="row align-items-center ">
                      <div className="col-md-5 image_box ">
                        <img src="/images/project/group/group_pic_4.webp" alt="" />
                        {/* <span className="blog-tag">{tag}</span> */}
                      </div>
                      <div className="col-md-7  ">
                        <div className="md-pl-30">
                          <p class=" mb-2 mt-20  fw-500 text-justify">
                            <b>
                          Another breakthrough came in 2015, when we opened our training center with a vision to create skilled youth that are able to create gainful employment. Our training center has successfully completed more than 80 batches with a very high employment percentage. Our training modules are specially curated to meet the needs of today's corporate world.
                          </b>
                          </p>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>

                </div>
              </div>
            </div>
                </div>

          </section>
          <section className='team-area  sub-bg pt-50 pb-120'>
          <div className='container'>
                 <div className=" row align-items-center ">
                   <div className="col-md-7 ">
                     {/* <h4 class="  py-2 fs-30 fw-bold ">Work with us</h4> */}
                     <div>
                       <p class=" mb-2 mt-20  fw-500 text-justify">
                        <b>
                        The hospitality industry is a major contributor to the global economy, understanding this very need our hospitality program was launched. Hospitality Skill Development Programme in Association with Le Meridien, New Delhi was a huge success. The programme started in 2016 and ran for four years till 2020, and it was indeed an incredible journey. An intensive theory and practical knowledge session created youth that were ready for all departments of the hospitality industry. The placement percentage was as high as 90% each year. 
                        </b>

                       </p>
                     </div>
                   </div>
                   <div className="col-md-5 image_box ">
                     <img src="/images/project/alumni/career-2.webp" alt="" />
                     {/* <span className="blog-tag">{tag}</span> */}
                   </div>
                 </div>
                 </div>

          </section>

        {/* <!-- Testimonial area start here --> */}
        <TestimonialSlider/>
       
        {/* <!-- Testimonial area end here --> */}
    </main>
     </>
    );

}
export default About;